<template>
  <v-dialog v-model="dialog" max-width="600px" persistent scrollable>
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title>
          <h4>{{ isEdit ? "Edit Business" : "Create Business" }}</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" color="black" size="30">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto" class="px-4 pt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="business.name"
            label="Company Name"
            :rules="[(v) => !!v || 'Company Name is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="business.email"
            label="Email"
            :rules="[
              (v) => !!v || 'Email is required',
              (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
            ]"
            required
          ></v-text-field>
          <v-text-field
            v-model="business.tel"
            label="Telephone"
            :rules="[
              (v) => !!v || 'Telephone is required',
              (v) =>
                (v.length >= 9 && v.length <= 10) ||
                'Telephone must be between 9 and 10 characters long',
            ]"
            required
          ></v-text-field>
          <v-select
            v-model="business.status"
            :items="[
              { text: 'Pending', value: 1 },
              { text: 'Approve', value: 2 },
              { text: 'Reject', value: 3 },
              { text: 'Edit document', value: 5 },
            ]"
            label="Status"
            :rules="[(v) => !!v || 'Status is required']"
            required
          ></v-select>
          <v-text-field
            v-model="business.address"
            label="Address"
            :rules="[(v) => !!v || 'Address is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="business.bank_number"
            label="Bank Number"
            :rules="[(v) => !!v || 'Bank Number is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="business.customer_id_card"
            label="Customer ID Card"
            :rules="[(v) => !!v || 'Customer ID Card is required']"
            required
          ></v-text-field>
          <v-text-field
            v-model="business.juristic_id"
            label="Juristic ID"
            :rules="[(v) => !!v || 'Juristic ID is required']"
            required
          ></v-text-field>
          <v-autocomplete
            v-model="business.province_id"
            :items="provinces"
            label="Province"
            :rules="[(v) => !!v || 'Province is required']"
            required
            item-text="province_name_th"
            item-value="province_id"
            :loading="loadingProvinces"
            @change="selectProvince"
          ></v-autocomplete>
          <v-autocomplete
            v-model="business.district_id"
            :items="districts"
            label="District"
            :rules="[(v) => !!v || 'District is required']"
            required
            item-text="district_name_th"
            item-value="district_id"
            :loading="loadingDistricts"
            @change="selectDistrict"
          ></v-autocomplete>
          <v-autocomplete
            v-model="business.sub_district_id"
            :items="subDistricts"
            label="Sub District"
            :rules="[(v) => !!v || 'Sub District is required']"
            required
            item-text="sub_district_name_th"
            item-value="sub_district_id"
            :loading="loadingSubDistricts"
          ></v-autocomplete>
          <v-autocomplete
            v-model="business.zipcode_id"
            :items="zipcodes"
            label="Zipcode"
            :rules="[(v) => !!v || 'Zipcode is required']"
            required
            item-text="zipcode_code"
            item-value="zipcode_id"
            :loading="loadingZipcodes"
          ></v-autocomplete>
          <v-autocomplete
            v-model="business.type"
            :items="[
              { text: 'บุคคลธรรมดา', value: '1' },
              { text: 'นิติบุคคล', value: '2' },
            ]"
            label="Type"
            :rules="[(v) => !!v || 'Type is required']"
            required
          ></v-autocomplete>
          <v-text-field v-model="business.remark" label="Remark"></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions style="padding-bottom: 30px" class="pr-4">
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          style="
            width: 120px;
            background: #000000 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 7px;
            font-weight: bold;
            letter-spacing: 0.1rem;
            color: white;
          "
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          color="success"
          style="
            width: 120px;
            background: #000000 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 7px;
            font-weight: bold;
            letter-spacing: 0.1rem;
            color: white;
          "
          @click="saveBusiness"
          :loading="saving"
        >
          {{ isEdit ? "Update" : "Save" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    businessData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      business: {
        name: "",
        email: "",
        tel: "",
        status: null,
        address: "",
        bank_number: "",
        customer_id_card: "",
        juristic_id: "",
        province_id: null,
        district_id: null,
        sub_district_id: null,
        zipcode_id: null,
        type: null,
        remark: "",
      },
      districts: [], // Populate with actual data
      subDistricts: [], // Populate with actual data
      zipcodes: [], // Populate with actual data
      loadingProvinces: false,
      loadingDistricts: false,
      loadingSubDistricts: false,
      loadingZipcodes: false,
      provinces: [],
      saving: false,
    };
  },
  computed: {
    isEdit() {
      return !!this.businessData.company_provider_wesmart_id;
    },
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.business = {
          company_id: this.businessData.company_provider_wesmart_id || null,
          name: this.businessData.company_provider_wesmart_name || "",
          email: this.businessData.company_provider_wesmart_email || "",
          tel: this.businessData.company_provider_wesmart_tel || "",
          status: this.businessData.company_provider_wesmart_status || null,
          address: this.businessData.company_provider_wesmart_address || "",
          bank_number:
            this.businessData.company_provider_wesmart_bank_number || "",
          customer_id_card:
            this.businessData.company_provider_wesmart_customer_id_card || "",
          juristic_id:
            this.businessData.company_provider_wesmart_juristic_id || "",
          province_id:
            this.businessData.company_provider_wesmart_province_id || null,
          district_id:
            this.businessData.company_provider_wesmart_district_id || null,
          sub_district_id:
            this.businessData.company_provider_wesmart_sub_district_id || null,
          zipcode_id:
            this.businessData.company_provider_wesmart_zipcode_id || null,
          type: this.businessData.company_provider_wesmart_type || null,
          remark: this.businessData.company_provider_wemsart_remark || "",
        };
        if (this.isEdit) {
          this.getDistrictList();
          this.getSubDistrictList();
          this.getZipcodeList();
        } else {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        }
      }
    },
  },
  methods: {
    ...mapActions({
      fetchProvinceList: "fetchProvinceBack/getProvinceCore",
      fetchDistrictList: "fetchProvinceBack/getDistrictCore",
      fetchSubDistrictList: "fetchProvinceBack/getSubDistrictCore",
      fetchZipcodeList: "fetchProvinceBack/getZipCodeCore",
    }),
    closeDialog() {
      this.$emit("close", false);
      this.resetForm();
    },
    saveBusiness() {
      if (this.$refs.form.validate()) {
        let businessClone = JSON.parse(JSON.stringify(this.business));
        if (businessClone.tel.startsWith("0")) {
          businessClone.tel = businessClone.tel.substring(1);
        }
        this.saving = true;
        let _this = this;
        this.$emit("save", {
          data: businessClone,
          done() {
            _this.saving = false;
            _this.resetForm();
          },
          failed() {
            _this.saving = false;
          },
        });
      }
    },
    async selectProvince(newVal) {
      console.log(newVal);

      this.districts = [];
      this.subDistricts = [];
      this.zipcodes = [];
      this.business.district_id = null;
      this.business.sub_district_id = null;
      this.business.zipcode_id = null;
      this.getDistrictList();
    },
    async selectDistrict(newVal) {
      this.subDistricts = [];
      this.zipcodes = [];
      this.business.sub_district_id = null;
      this.business.zipcode_id = null;
      this.getSubDistrictList();
      this.getZipcodeList();
    },
    async getProvinceList() {
      this.loadingProvinces = true;
      this.provinces = await this.fetchProvinceList();
      this.loadingProvinces = false;
    },
    async getDistrictList() {
      this.loadingDistricts = true;
      this.districts = await this.fetchDistrictList(this.business.province_id);
      this.loadingDistricts = false;
    },
    async getSubDistrictList() {
      this.loadingSubDistricts = true;
      this.subDistricts = await this.fetchSubDistrictList(
        this.business.district_id
      );
      this.loadingSubDistricts = false;
    },
    async getZipcodeList() {
      this.loadingZipcodes = true;
      this.zipcodes = await this.fetchZipcodeList(this.business.district_id);
      this.loadingZipcodes = false;
    },
    resetForm() {
      this.business = {
        name: "",
        email: "",
        tel: "",
        status: null,
        address: "",
        bank_number: "",
        customer_id_card: "",
        juristic_id: "",
        province_id: null,
        district_id: null,
        sub_district_id: null,
        zipcode_id: null,
        type: null,
        remark: "",
      };
    },
  },
  async created() {
    this.getProvinceList();
  },
};
</script>

<style>
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
